import React, { useEffect, useRef, useState } from 'react';
import ExpertiseCard from './ExpertiseCard';
import { expertise } from '../../data/portfolioData';
import './Expertise.css';

const Expertise = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observers = cardsRef.current.map((card, index) => {
      if (!card) return null;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleCards(prev => [...new Set([...prev, index])]);
            observer.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      observer.observe(card);
      return observer;
    });
    return () => observers.forEach(o => o && o.disconnect());
  }, []);

  return (
    <section className="expertise-section" id= "expertise">
      <div className="section-header">
        <span className="section-tag">WHAT I DO</span>
        <h2>My Expertise</h2>
        <p>Comprehensive QA solutions across multiple platforms and technologies</p>
      </div>
      <div className="expertise-grid">
        {expertise.map((item, index) => {
          const isVisible = visibleCards.includes(index);
          const fromLeft = index % 2 === 0;
          return (
            <div
              key={index}
              ref={el => cardsRef.current[index] = el}
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible
                  ? 'translateX(0)'
                  : `translateX(${fromLeft ? '-60px' : '60px'})`,
                transition: `opacity 0.6s ease ${index * 100}ms, transform 0.6s ease ${index * 100}ms`,
              }}
            >
              <ExpertiseCard item={item} />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Expertise;
